import { render, staticRenderFns } from "./SEPAPayment.vue?vue&type=template&id=27160028"
import script from "./SEPAPayment.vue?vue&type=script&lang=js"
export * from "./SEPAPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports